import React from 'react';
import PropTypes from 'prop-types';
import { withTranslations } from 'react-utilities';
import { translationConfig } from './app.config';
import SubscriptionPageBase from './containers/SubscriptionPageBase';

function App({ translate, intl }) {
  return <SubscriptionPageBase translate={translate} intl={intl} />;
}

App.propTypes = {
  translate: PropTypes.func.isRequired,
  intl: PropTypes.shape({
    d: PropTypes.func.isRequired
  }).isRequired
};

export default withTranslations(App, translationConfig);
